export enum StartPointCommandesClientsEnum {
  PLC = 'PLC',
  REPAS = 'REPAS',
  PRESTATION = 'PRESTATION',
  PRODUIT_COMPLEMENTAIRE = 'PRODUIT_COMPLEMENTAIRE'
}
